import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import { SegmentedTabs } from '../../../../components/segmentedTabs';
import HomebaseTab from '../store/HomebaseTab';

interface HomeBaseTabListProps {
    onChange: (event: React.SyntheticEvent, nextTabId: number) => void;
    selectedTabId: number;
}

const tabs = [
    { label: 'Viewed', id: HomebaseTab.RecentlyViewed },
    { label: 'Searched', id: HomebaseTab.Searched },
    { label: 'You might like', id: HomebaseTab.Recommended },
];

export const HomeBaseTabList = ({ onChange, selectedTabId }: HomeBaseTabListProps) => (
    <Stack direction="row" sx={{ width: '100%', justifyContent: 'center' }}>
        <SegmentedTabs
            className="hp-tab-bar"
            value={selectedTabId}
            onChange={onChange}
            aria-label="Car Carousel Tabs"
            textColor="secondary"
            sx={{
                width: '39rem',
                backdropFilter: 'blur(30px)',
                background: 'rgba(0, 19, 51, 0.24)',
                '.MuiTab-root.Mui-selected': {
                    borderColor: 'white',
                },
            }}
        >
            {tabs.map(({ label, id }) => (
                <Tab key={id} label={label} sx={{ typography: 'h5', color: 'white' }} />
            ))}
        </SegmentedTabs>
    </Stack>
);
